import {
  GUIDE_TOUR_STEP_CARD_SIZES,
  type GuideTourStepCardSize,
} from '../types'
import { GuideTourValidationError } from './errors'

export const isGuideTourStepCardSize = (
  value: unknown
): value is GuideTourStepCardSize =>
  typeof value === 'string' &&
  (GUIDE_TOUR_STEP_CARD_SIZES as readonly string[]).includes(value)

export const validateGuideTourCardSize = (
  cardSize: unknown,
  fieldName: string
): void => {
  if (cardSize === undefined) {
    return
  }

  if (!isGuideTourStepCardSize(cardSize)) {
    throw new GuideTourValidationError(
      `${fieldName} must be one of: ${GUIDE_TOUR_STEP_CARD_SIZES.join(', ')}`
    )
  }
}
